import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Field } from 'nallian-shared-ui/lib/components';
import {
  InputFieldValueComponent,
  SelectFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import ReadOnlyFieldValueComponent from '../../../../app/components/ReadOnlyFieldValueComponent';

const CommunityAppDetails = ({ actionId, submitProcessing, dataLoading, appOptions, readOnly }) => {
  const { t } = useTranslation();

  return (
    <Grid margin="0rem -1rem">
      {!actionId && (
        <Grid.Column mobile={16} tablet={16} computer={16}>
          <Field
            fluid
            search
            label={t('app')}
            name="appInstallation.id"
            options={appOptions}
            valueComponent={readOnly ? ReadOnlyFieldValueComponent : SelectFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
      )}
      <Grid.Column mobile={8} tablet={8} computer={8}>
        <Field
          fluid
          label={t('alias')}
          name="alias"
          valueComponent={readOnly ? ReadOnlyFieldValueComponent : InputFieldValueComponent}
          disabled={submitProcessing || dataLoading}
        />
      </Grid.Column>
    </Grid>
  );
};

CommunityAppDetails.propTypes = {
  actionId: PropTypes.string.isRequired,
  submitProcessing: PropTypes.bool.isRequired,
  dataLoading: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  appOptions: PropTypes.array,
};

CommunityAppDetails.defaultProps = { appOptions: [] };

export default CommunityAppDetails;
